import { ELOQUA_PREPOP_FAILURE, ELOQUA_PREPOP_REQUEST, ELOQUA_PREPOP_SUCCESS } from "./eloqua-action-types";
import { prePopulateEloquaData } from "./eloqua-services";

export const eloquaDataRequest = () => ({
    type: ELOQUA_PREPOP_REQUEST
});

const eloquaDataSuccess = (eloquaData) => ({
    type: ELOQUA_PREPOP_SUCCESS,
    response: eloquaData
});

const eloquaDataFailure = (errorObj) => ({
    type: ELOQUA_PREPOP_FAILURE,
    error: errorObj
});

export const fetchEloquaData = () => async (dispatch) => {
    dispatch(eloquaDataRequest);
    try {
        const eloquaData = await prePopulateEloquaData();
        dispatch(eloquaDataSuccess(eloquaData));
    } catch (err) {
        dispatch(eloquaDataFailure(err));
    }
};

export default {
    fetchEloquaData
};
